import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Sticker } from "lucide-react";
import { LEVELS } from "../data/curriculum";
import { sfx } from "../services/soundfx";
import { speak } from "../services/phonicsAudio";

// Full sticker set the child can collect (base + gold per level).
function allSlots() {
  const slots = [];
  LEVELS.forEach((l) => {
    slots.push({ level_id: l.id, kind: "base", emoji: l.sticker || levelEmoji(l.id), title: l.title });
    slots.push({ level_id: l.id, kind: "gold", emoji: "🏅", title: `${l.title} — 3 stars!` });
  });
  return slots;
}
function levelEmoji(id) {
  return { 1: "🦁", 2: "🐠", 3: "🌉", 7: "🚀", 4: "🫧", 5: "🪄", 6: "📖" }[id] || "⭐";
}

export default function StickerBook({ stickers = [], onClose }) {
  const owned = new Set(stickers.map((s) => `${s.level_id}:${s.kind}`));
  const slots = allSlots();
  const count = stickers.length;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4 no-select" style={{ background: "#0F172A99", backdropFilter: "blur(8px)" }} data-testid="sticker-book">
      <motion.div
        initial={{ scale: 0.8, opacity: 0, y: 30 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        className="relative w-full max-w-lg rounded-[2rem] bg-white border-[6px] border-amber-300 shadow-2xl p-6"
      >
        <button data-testid="close-sticker-book" onClick={() => { sfx.tap(); onClose(); }} className="absolute top-4 right-4 rounded-full bg-slate-100 p-2">
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2 mb-1">
          <Sticker className="w-7 h-7 text-amber-500" />
          <h2 className="font-display text-3xl font-black text-amber-500">My Stickers</h2>
        </div>
        <p className="font-bold text-slate-400 mb-5">{count} collected</p>

        <div className="grid grid-cols-4 sm:grid-cols-5 gap-3">
          <AnimatePresence>
            {slots.map((slot) => {
              const have = owned.has(`${slot.level_id}:${slot.kind}`);
              return (
                <motion.button
                  key={`${slot.level_id}-${slot.kind}`}
                  onClick={() => { if (have) { sfx.star(); speak("Nice sticker!"); } }}
                  whileTap={have ? { scale: 0.9, rotate: -6 } : {}}
                  className={`aspect-square rounded-2xl flex items-center justify-center text-4xl border-4 ${have ? "bg-amber-50 border-amber-300 shadow" : "bg-slate-100 border-dashed border-slate-300"}`}
                  data-testid={`sticker-${slot.level_id}-${slot.kind}`}
                >
                  <span style={{ filter: have ? "none" : "grayscale(1) opacity(0.35)" }}>{slot.emoji}</span>
                </motion.button>
              );
            })}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
}
